/* GOB Light kit finder (V174, usage tracking V176)
   Search all kits in the collection by set number or name (typo tolerant).
   Dropdown: top 5. Grid: shows the matching kits as the store's own cards
   (rendered by /search?view=recently-viewed&q=id:..), so prices, GOB Club and quick add stay exact. */
(function () {
  'use strict';
  if (window.__gkf) return; window.__gkf = true;
  var roots = [].slice.call(document.querySelectorAll('[data-gkf]')).filter(function (r) { return !r.closest('#CollectionInlineFilterWrap, .collection-mobile-filters, .drawer'); });
  if (!roots.length) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SEARCH = (window.theme && theme.routes && theme.routes.search) || (ROOT + 'search');
  var IDX = roots[0].getAttribute('data-gkf-index');
  var K = null, loading = null;

  /* ---------- usage tracking (V176) ----------
     Anonymous events to Supabase gob-kf-track: browser-tab session id (shared gob_sid), random page id,
     finder (hero = phones, side = desktop), collection handle, query, result count, clicked product.
     No IP, no customer data. Theme previews and the editor are flagged t = 1 and left out of the stats. */
  var TRK = 'https://ayflivmnbjberbmvimtg.supabase.co/functions/v1/gob-kf-track';
  var rid = function () { return (Date.now().toString(36) + Math.random().toString(36).slice(2, 10)).slice(0, 18); };
  var PV = rid(), SID = PV;
  try { SID = sessionStorage.getItem('gob_sid') || ''; if (!SID) { SID = rid(); sessionStorage.setItem('gob_sid', SID); } } catch (e) { SID = PV; }
  var TEST = !!(window.Shopify && (Shopify.designMode || (Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main')));
  var COLL = (location.pathname.match(/\/collections\/([^\/?#]+)/) || [])[1] || '';
  var lastMode = '';
  function modeOf(r) { return r && r.classList && r.classList.contains('gkf--hero') ? 'hero' : 'side'; }
  function track(ev, r, o) {
    try {
      o = o || {}; var m = r ? modeOf(r) : lastMode; if (r) lastMode = m;
      var b = JSON.stringify({ ev: ev, sid: SID, pv: PV, m: m, dv: window.matchMedia('(min-width: 769px)').matches ? 'd' : 'm', c: COLL,
        q: o.q ? String(o.q).trim().slice(0, 40) : '', n: o.n, h: o.h || '', p: o.p, t: TEST ? 1 : 0 });
      if (!(navigator.sendBeacon && navigator.sendBeacon(TRK, new Blob([b], { type: 'text/plain' }))))
        fetch(TRK, { method: 'POST', body: b, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
    } catch (e) {}
  }
  var sentQ = {};
  function trackQuery(ev, r, q) {
    q = (q || '').trim(); if (q.length < 2) return;
    var k = ev + '|' + q.toLowerCase(); if (sentQ[k]) return; sentQ[k] = 1;
    load().then(function () { track(ev, r, { q: q, n: find(q).length }); }).catch(function () { track(ev, r, { q: q }); });
  }
  function handleOf(a) { var m = (a && a.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }

  var TW = { sw: 'star wars', hp: 'harry potter wizarding world', hero: 'marvel dc superhero batman avengers', disney: 'disney', xmas: 'christmas winter village xmas', veh: 'car cars technic vehicle supercar', space: 'space spaceship plane aircraft rocket', build: 'building buildings modular architecture', ideas: 'ideas', bot: 'botanical flowers plants bonsai' };
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[®™©]/g, '').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function theme_(k) {
    var a = k.a || '', t = k.n.toLowerCase(), pt = k.pt || '';
    if (/star.?wars|starwars/.test(a + ' ' + t)) return 'sw';
    if (/harry potter|hogwarts/.test(a + ' ' + t)) return 'hp';
    if (/marvel|avengers|batman/.test(a)) return 'hero';
    if (/disney/.test(a + ' ' + t)) return 'disney';
    if (/christmas/.test(pt + ' ' + t) || /winter village/.test(t)) return 'xmas';
    if (/cars|trains/.test(pt)) return 'veh';
    if (/spaceships/.test(pt)) return 'space';
    if (/building/.test(pt)) return 'build';
    if (/ideas/.test(pt)) return 'ideas';
    if (/botanical/.test(pt)) return 'bot';
    return 'other';
  }
  function prep(items) {
    items.forEach(function (k, i) {
      var m = k.n.match(/\b(\d{4,6})\b/); k.s = m ? m[1] : ''; k.r = i;
      k._n = norm(k.n); k._w = k._n.split(' '); k._a = norm((k.a || '') + ' ' + (TW[theme_(k)] || ''));
    });
    return items;
  }
  function getJSON(u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }); }
  function load() {
    if (K) return Promise.resolve(K);
    if (loading) return loading;
    var key = 'gkf:' + IDX;
    try { var c = JSON.parse(sessionStorage.getItem(key) || 'null'); if (c && c.t > Date.now() - 6 * 3600e3 && c.items && c.items.length) { K = prep(c.items); return Promise.resolve(K); } } catch (e) {}
    loading = getJSON(IDX + '&page=1').then(function (first) {
      var rest = []; for (var p = 2; p <= first.pages; p++) rest.push(getJSON(IDX + '&page=' + p));
      return Promise.all(rest).then(function (pages) {
        var items = first.items; pages.forEach(function (pg) { items = items.concat(pg.items); });
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), items: items })); } catch (e) {}
        K = prep(items); return K;
      });
    }).catch(function (e) { loading = null; throw e; });
    return loading;
  }

  function ed(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var p = [], c, i, j; for (j = 0; j <= b.length; j++) p[j] = j;
    for (i = 1; i <= a.length; i++) { c = [i]; var m = i;
      for (j = 1; j <= b.length; j++) { c[j] = Math.min(p[j] + 1, c[j - 1] + 1, p[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)); if (c[j] < m) m = c[j]; }
      if (m > max) return max + 1; p = c; }
    return p[b.length];
  }
  function tokScore(t, k) {
    if (/^\d+$/.test(t)) {
      if (k.s === t) return 100; if (k.s && k.s.indexOf(t) === 0 && t.length >= 2) return 55;
      return k._n.indexOf(t) > -1 ? 30 : 0;
    }
    var best = 0, w, x, e;
    for (w = 0; w < k._w.length; w++) { x = k._w[w];
      if (x === t) { best = Math.max(best, 12); continue; }
      if (t.length >= 2 && x.indexOf(t) === 0) { best = Math.max(best, 8); continue; }
      if (t.length >= 4) { e = ed(t, x.slice(0, Math.max(t.length, x.length)), 2);
        if (e <= 1 || (e === 2 && t.length >= 7)) best = Math.max(best, 5); } }
    if (!best && t.length >= 3 && k._a.indexOf(t) > -1) best = 6;
    if (!best && t.length >= 4 && k._a) { var aw = k._a.split(' ');
      for (var j = 0; j < aw.length; j++) if (ed(t, aw[j], 1) <= 1) { best = 3; break; } }
    return best;
  }
  var STOP = ['light', 'lights', 'kit', 'kits', 'lego', 'for', 'set', 'the', 'led'];
  function find(q) {
    var all = norm(q).split(' ').filter(Boolean), ts = all.filter(function (t) { return STOP.indexOf(t) < 0; });
    if (!ts.length) ts = all; if (!ts.length || !K) return [];
    var out = [];
    for (var i = 0; i < K.length; i++) { var k = K[i], sum = 0, ok = true;
      for (var j = 0; j < ts.length; j++) { var sc = tokScore(ts[j], k); if (!sc) { ok = false; break; } sum += sc; }
      if (ok) out.push({ k: k, s: sum * 10 + (K.length - i) / 1000 }); }
    out.sort(function (a, b) { return b.s - a.s; });
    if (out.length) { var top = out[0].s; out = out.filter(function (r) { return r.s >= top * 0.35; }); }
    return out.map(function (r) { return r.k; });
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function purl(k) { return ROOT + 'products/' + k.h; }

  /* ---------- grid ---------- */
  var grid = document.querySelector('.gobd34-grid') || document.querySelector('.collection-grid');
  var orig = null, wrap = null, pag = document.querySelector('.pagination');
  var counts = [].slice.call(document.querySelectorAll('.collection-filter__item--count, [data-collection-count]'));
  var countTxt = counts.map(function (c) { return c.innerHTML; });
  var more = null, empty = null, state = { q: '', res: [], shown: 0, tok: 0 };
  if (grid) {
    more = document.createElement('div'); more.className = 'gkf-more'; more.hidden = true;
    more.innerHTML = '<button type="button">Show more kits</button>';
    grid.parentNode.insertBefore(more, grid.nextSibling);
    more.firstChild.addEventListener('click', function () { renderGrid(state.shown + 24); });
    empty = document.createElement('div'); empty.className = 'gkf-empty'; empty.hidden = true;
    grid.parentNode.insertBefore(empty, grid);
  }
  if (grid) grid.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.gkf-res a[href*="/products/"]'); if (!a || !state.q.trim()) return;
    var cards = [].slice.call(grid.querySelectorAll('.gkf-res .grid-product[data-product-id]')), card = a.closest('.grid-product');
    track('card', null, { q: state.q, n: state.res.length, h: handleOf(a), p: cards.indexOf(card) + 1 || undefined });
  }, true);
  function setCount(txt) { counts.forEach(function (c, i) { c.innerHTML = txt === null ? countTxt[i] : esc(txt); }); }
  function restore() {
    if (!grid || !orig) return;
    if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap);
    grid.appendChild(orig); orig = null; wrap = null;
    if (pag) pag.hidden = false; more.hidden = true; empty.hidden = true; setCount(null);
  }
  function renderGrid(n) {
    if (!grid) return;
    var res = state.res, tok = ++state.tok;
    if (!orig) { orig = document.createDocumentFragment(); while (grid.firstChild) orig.appendChild(grid.firstChild); }
    if (pag) pag.hidden = true;
    setCount(res.length + (res.length === 1 ? ' kit' : ' kits') + ' for “' + state.q.trim() + '”');
    if (!res.length) {
      if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap); wrap = null;
      more.hidden = true; empty.hidden = false;
      empty.innerHTML = '<b>No kit for “' + esc(state.q.trim()) + '” yet.</b><span>Check the number on the front of your LEGO® box, or try the set name.</span>';
      return;
    }
    empty.hidden = true;
    var from = n > 24 ? state.shown : 0, ids = res.slice(from, n).map(function (k) { return k.id; });
    document.documentElement.classList.add('gkf-busy');
    /* search pages return 10 results, so ask in batches of 10 ids */
    var chunks = []; for (var ci = 0; ci < ids.length; ci += 10) chunks.push(ids.slice(ci, ci + 10));
    Promise.all(chunks.map(function (ch) {
      return fetch(SEARCH + '?view=recently-viewed&type=product&q=' + encodeURIComponent(ch.map(function (i) { return 'id:' + i; }).join(' OR ')), { credentials: 'same-origin' }).then(function (r) { return r.text(); });
    }))
      .then(function (txts) {
        if (tok !== state.tok) return;
        var box = document.createElement('div'); box.innerHTML = txts.join('');
        var byId = {};
        [].slice.call(box.querySelectorAll('.grid-product[data-product-id]')).forEach(function (c) {
          var id = c.getAttribute('data-product-id'), modal = document.getElementById('QuickShopModal-' + id) || box.querySelector('#QuickShopModal-' + id);
          byId[id] = [c, modal];
        });
        if (from === 0) { if (wrap && wrap.parentNode) wrap.parentNode.removeChild(wrap); wrap = document.createElement('div'); wrap.className = 'gkf-res'; grid.appendChild(wrap); }
        var add = document.createElement('div'); add.className = 'gkf-res';
        ids.forEach(function (id) { var x = byId[String(id)]; if (!x) return; add.appendChild(x[0]); if (x[1] && !document.getElementById(x[1].id)) add.appendChild(x[1]); });
        wrap.appendChild(add);
        state.shown = n; more.hidden = res.length <= n;
        more.firstChild.textContent = 'Show more kits (' + (res.length - n) + ' left)';
        try { if (window.theme && theme.QuickAdd) new theme.QuickAdd(add); if (window.theme && theme.QuickShop) new theme.QuickShop(add); if (window.theme && theme.reinitProductGridItem) theme.reinitProductGridItem(add); } catch (e) {}
      })
      .catch(function () {})
      .then(function () { if (tok === state.tok) document.documentElement.classList.remove('gkf-busy'); });
  }
  var gt;
  function setQuery(q, now) {
    state.q = q || '';
    clearTimeout(gt);
    if (!state.q.trim()) { state.tok++; document.documentElement.classList.remove('gkf-busy'); restore(); return; }
    gt = setTimeout(function () { load().then(function () { state.res = find(state.q); renderGrid(24); }); }, now ? 0 : 350);
  }
  function scrollToGrid() {
    var t = document.querySelector('.collection-content') || grid; if (!t) return;
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
  }

  /* ---------- inputs ---------- */
  function wire(root) {
    var inp = root.querySelector('.gkf-in'), x = root.querySelector('.gkf-x'), dd = root.querySelector('.gkf-dd'), act = -1, rows = [], st, focused = false;
    if (!inp) return;
    dd.addEventListener('mousedown', function (e) {
      var a = e.target.closest && e.target.closest('.gkf-row'); if (!a) return;
      track('pick', root, { q: inp.value, n: undefined, h: handleOf(a), p: rows.indexOf(a) + 1 || undefined });
    });
    function drop() {
      var q = inp.value.trim();
      if (!q || document.activeElement !== inp) { dd.hidden = true; return; }
      load().then(function () {
        if (inp.value.trim() !== q) return;
        var r = find(q); act = -1;
        if (!r.length) { dd.innerHTML = '<div class="gkf-none"><b>No kit for “' + esc(q) + '” yet</b>Try the number on the front of your LEGO® box.</div>'; dd.hidden = false; rows = []; return; }
        dd.innerHTML = r.slice(0, 5).map(function (k) {
          return '<a class="gkf-row" href="' + purl(k) + '">' + (k.i ? '<img src="' + esc(k.i) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="gkf-ph"></span>') +
            '<span><span class="gkf-s">' + (k.s ? 'Set ' + k.s : 'Light kit') + '</span><span class="gkf-t">' + esc(k.n) + '</span></span>' +
            '<span class="gkf-p">' + esc(k.p) + '<small>Club ' + esc(k.c) + '</small></span></a>';
        }).join('') + '<button type="button" class="gkf-all">See all ' + r.length + ' result' + (r.length > 1 ? 's' : '') + '</button>';
        rows = [].slice.call(dd.querySelectorAll('.gkf-row')); dd.hidden = false;
        dd.querySelector('.gkf-all').addEventListener('mousedown', function (e) { e.preventDefault(); trackQuery('all', root, inp.value); dd.hidden = true; inp.blur(); setQuery(inp.value, true); scrollToGrid(); });
      }).catch(function () { dd.hidden = true; });
    }
    inp.addEventListener('input', function () { x.hidden = !inp.value; setQuery(inp.value); drop();
      clearTimeout(st); st = setTimeout(function () { trackQuery('search', root, inp.value); }, 1500); });
    inp.addEventListener('focus', function () { if (!focused) { focused = true; track('focus', root); } load().catch(function () {}); drop(); });
    inp.addEventListener('blur', function () { setTimeout(function () { dd.hidden = true; }, 150); });
    inp.addEventListener('keydown', function (e) {
      if (!dd.hidden && rows.length && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) { e.preventDefault(); act = (act + (e.key === 'ArrowDown' ? 1 : -1) + rows.length) % rows.length; rows.forEach(function (r, i) { r.classList.toggle('is-act', i === act); }); return; }
      if (e.key === 'Enter') { e.preventDefault(); if (!dd.hidden && act > -1 && rows[act]) { track('pick', root, { q: inp.value, h: handleOf(rows[act]), p: act + 1 }); location.href = rows[act].href; return; } trackQuery('all', root, inp.value); dd.hidden = true; inp.blur(); setQuery(inp.value, true); scrollToGrid(); }
      if (e.key === 'Escape') { inp.value = ''; x.hidden = true; dd.hidden = true; setQuery(''); }
    });
    x.addEventListener('click', function () { inp.value = ''; x.hidden = true; setQuery('', true); inp.focus(); });
    [].slice.call(root.querySelectorAll('[data-gkf-q]')).forEach(function (c) {
      c.addEventListener('click', function () { trackQuery('chip', root, c.getAttribute('data-gkf-q')); inp.value = c.getAttribute('data-gkf-q'); x.hidden = false; setQuery(inp.value, true); scrollToGrid(); });
    });
    root.addEventListener('pointerenter', function () { load().catch(function () {}); }, { once: true });
  }
  roots.forEach(wire);
  /* seen: once per page load for each finder that is actually shown (hero on phones, side card on desktop) */
  setTimeout(function () { roots.forEach(function (r) { if (r.offsetParent !== null) track('seen', r); }); }, 800);
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)) return;
    var v = roots.map(function (r) { return r.querySelector('.gkf-in'); }).filter(function (i) { return i && i.offsetParent; })[0];
    if (v) { e.preventDefault(); v.focus(); }
  });
  /* ?q= prefill (ad final URL, e.g. ?q=10294) */
  var q0 = new URLSearchParams(location.search).get('q');
  if (q0) {
    roots.forEach(function (r) { var i = r.querySelector('.gkf-in'); i.value = q0; r.querySelector('.gkf-x').hidden = false; });
    setQuery(q0, true);
    var vis = roots.filter(function (r) { return r.offsetParent !== null; })[0] || roots[0];
    trackQuery('url', vis, q0);
  }
})();
